import QueryResults from "./QueryResults";

export default class QueryResults_Filmografia extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
  }

  getColumns() {
    let columnDefs = [
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Titolo
      this.fr.fieldList("label", "Titolo", 2, this.dispatch.bind(this), "CFILMOGRAFIA_titolo", null, null, null, null, null, { type: QueryResults.SCHEDA_TYPE_FILM, prop: "id" }),
      // Produzione
      this.fr.fieldList("produzione_scheda_PRD", "Produzione", 2),
      // Data
      this.fr.fieldList("cronologia_datazione_scheda_DT", "Data", 1, null, null, "data_DTI"),
      // Regista
      this.fr.fieldList("registi", "Regista", 2, this.dispatch.bind(this), "CFILMOGRAFIA_regista", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "registi.rel_entity_id", key: "rel_entity_id" }),
      // Interpreti
      this.fr.fieldList("interpreti", "Interpreti", 2, this.dispatch.bind(this), "CFILMOGRAFIA_interprete", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "interpreti.rel_entity_id", key: "rel_entity_id" }),
      // Sceneggiatura
      this.fr.fieldList("sceneggatori", "Sceneggiatura", 2, this.dispatch.bind(this), "CFILMOGRAFIA_sceneggiatore", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "sceneggatori.rel_entity_id", key: "rel_entity_id" }),
      // Scenografia
      this.fr.fieldList("scenografi", "Scenografia", 2, this.dispatch.bind(this), "CFILMOGRAFIA_scenografo", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "scenografi.rel_entity_id", key: "rel_entity_id" }),
      // Montaggio
      this.fr.fieldList("montatori", "Montaggio", 2, this.dispatch.bind(this), "CFILMOGRAFIA_montatore", "label", null, null, null, null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "montatori.rel_entity_id", key: "rel_entity_id" }),
      // NCNT
      this.fr.fieldPlain("numero_catalogo_generale_NCTN", "NCNT", 1),
    ];
    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }
}

QueryResults_Filmografia.QUERY_FILMOGRAFIA_titolo = {
  id: "QN1733213585773",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733213585777",
      Field: {
        _path: "/label",
        _label: "/Titolo del film",
        Name: "label",
        Label: "Titolo del film",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};

QueryResults_Filmografia.QUERY_FILMOGRAFIA_regista = {
  id: "QN1733214632615",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733214632616",
      Field: {
        _path: "/registi/label",
        _label: "/registi/Nome del regista",
        Name: "label",
        Label: "Nome del regista",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};

QueryResults_Filmografia.QUERY_FILMOGRAFIA_interprete = {
  id: "QN1733215302864",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733215302868",
      Field: {
        _path: "/interpreti/label",
        _label: "/interpreti/Nome interpreti",
        Name: "label",
        Label: "Nome interpreti",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};

QueryResults_Filmografia.QUERY_FILMOGRAFIA_sceneggiatore = {
  id: "QN1733218088256",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733218088257",
      Field: {
        _path: "/sceneggatori/label",
        _label: "/sceneggatori/Nome sceneggiatore",
        Name: "label",
        Label: "Nome sceneggiatore",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};

QueryResults_Filmografia.QUERY_FILMOGRAFIA_scenografo = {
  id: "QN1733218088256",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733218088258",
      Field: {
        _path: "/scenografi/label",
        _label: "/scenografi/Nome scenografo",
        Name: "label",
        Label: "Nome scenografo",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};

QueryResults_Filmografia.QUERY_FILMOGRAFIA_montatore = {
  id: "QN1733218088256",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1733218088259",
      Field: {
        _path: "/montatori/label",
        _label: "/montatori/Nome montatore",
        Name: "label",
        Label: "Nome montatore",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tALLTERMSw",
    },
  ],
  CollectionName: "FILMOGRAFIA_coll",
};
